// src/adminCompenents/listComponents/UI/DataCards.jsx
import React from "react";
import "./index.scss";

const DataCards = ({ columns, data, keyField, rowActions }) => {
  return (
    <div className="data-cards">
      {data.map((row) => (
        <div
          key={row[keyField]}
          className="data-card shadow-sm p-3 mb-3 rounded">
          {columns.map((col) => (
            <div key={col.accessor} className="card-field mb-2">
              <strong>{col.header}: </strong>
              {col.Cell ? col.Cell(row[col.accessor], row) : row[col.accessor]}
            </div>
          ))}

          {rowActions && (
            <div className="card-actions mt-2 d-flex gap-2">
              {rowActions(row).map((action, idx) => (
                <button
                  key={idx}
                  className="btn btn-sm btn-outline-primary"
                  onClick={action.onClick}>
                  {action.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DataCards;
